import React, { RefObject } from "react";
import { CorneredBoxInner, CorneredBoxWrapper } from "./CorneredBox.styled";

interface CorneredBoxProps {
  bgColorBack?:
    | "primary"
    | "secondary"
    | "darkBlue"
    | "skyBlue"
    | "white"
    | "lightSkyBlue"
    | "#F4F5F7"
    | "#42526E";
  bgColor?:
    | "primary"
    | "secondary"
    | "darkBlue"
    | "skyBlue"
    | "white"
    | "lightSkyBlue"
    | "joinNetwork"
    | "#F4F5F7"
    | "#42526E";
  paddingTop?: string;
  marginTop?: string;
  paddingBottom?: string;
  className?: string;
  innerClassName?: string;
  mobileBg?: string;
  children: React.ReactNode;
  zIndex?: number | string;
  id?: string;
  position?: string;
  ref?: RefObject<HTMLDivElement>;
}

const CorneredBox = ({
  id,
  children,
  bgColorBack,
  paddingTop,
  marginTop,
  paddingBottom,
  bgColor,
  className = "",
  innerClassName = "",
  mobileBg = "",
  zIndex,
  position,
  ref,
}: CorneredBoxProps) => (
  <CorneredBoxWrapper
    backgroundColor={bgColorBack}
    className={className}
    id={id}
    ref={ref}
  >
    <CorneredBoxInner
      id={"cornered_box"}
      backgroundColor={bgColor}
      position={position}
      className={innerClassName}
      style={{
        zIndex: zIndex ? zIndex : "unset",
        marginTop: marginTop ? marginTop : "0px",
        paddingBottom: paddingBottom ? paddingBottom : "0px",
        paddingTop: paddingTop ? paddingTop : "0px",
      }}
    >
      {children}
    </CorneredBoxInner>
  </CorneredBoxWrapper>
);

export default CorneredBox;
